import { Link, useLocation } from 'react-router-dom';
import {
  Map,
  User,
  LogOut,
  Compass,
  Swords,
  Droplets,
} from 'lucide-react';
import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarProvider,
  SidebarInset,
  SidebarFooter,
} from '@/components/ui/sidebar';
import { useUser, useAuth } from '@/firebase';
import { signOut } from 'firebase/auth';
import { Button } from '../ui/button';
import { MobileHeader } from './MobileHeader';
import { AuthStatus } from './AuthStatus';
import { AppLogo } from './AppLogo';


const menuItems = [
  { href: '/itinerary/discover', label: 'Discover Routes', icon: Compass },
  { href: '/itinerary', label: 'My Expeditions', icon: Swords },
  { href: '/locations', label: 'Swim Spots', icon: Droplets },
  { href: '/map', label: 'Interactive Map', icon: Map },
];

export function AppShell({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const pathname = location.pathname;
  const { user, isUserLoading } = useUser();
  const auth = useAuth();

  return (
    <SidebarProvider>
      <div className="relative flex min-h-screen w-full">
        <Sidebar
          collapsible="icon"
          side="left"
          className="hidden md:block border-r bg-sidebar text-sidebar-foreground"
        >
          <SidebarHeader className="p-4">
             <AppLogo />
          </SidebarHeader>
          <SidebarContent className="p-4">
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.label}>
                  <SidebarMenuButton
                    asChild
                    isActive={pathname === item.href || (item.href !== '/' && pathname.startsWith(item.href) && item.href.length > '/'.length)}
                    tooltip={{ children: item.label, className: 'bg-primary text-primary-foreground' }}
                  >
                    <Link to={item.href}>
                      <item.icon />
                      <span>{item.label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
               {(user || isUserLoading) && (
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    isActive={pathname.startsWith('/profile')}
                    tooltip={{ children: 'My Clan', className: 'bg-primary text-primary-foreground' }}
                  >
                    <Link to="/profile">
                      <User />
                      <span>My Clan</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              )}
            </SidebarMenu>
          </SidebarContent>
           <SidebarFooter className="p-4 border-t border-sidebar-border">
              <div className="flex items-center justify-between">
                <AuthStatus />
                {user && <Button variant="ghost" size="icon" onClick={() => signOut(auth)}><LogOut /></Button>}
              </div>
          </SidebarFooter>
        </Sidebar>
        <SidebarInset className="flex grow flex-col bg-background">
          <MobileHeader />
          <main className="flex-1 overflow-y-auto px-3 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8 animate-fade-in">
            {children}
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
